/* eslint-disable react/prop-types */

import { useState } from "react";
import { FlexContainers, GradientLoader, TextOverflowWrapper } from "../../../../components";
import { CellWrapper } from "../../../../components/Table/styled";
import { DeviceImageContainer } from "../../../Campaigns/FWUCampaign/FWUCampaignTable/styled";
import { deviceUtil } from "../../../../utils";

const DeviceCellComponent = ({ cell, width, searchedText }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [deviceImage, setDeviceImage] = useState();

  const record = cell?.row?.original;

  if (record.model) {
    deviceUtil.getDeviceImageAsset(deviceUtil.getDeviceImage(null, record.model)).then((res) => {
      setDeviceImage(res);
    });
  } else {
    deviceUtil.getDeviceImageAssetByType(cell.value, null).then((res) => {
      setDeviceImage(res);
    });
  }

  return (
    <CellWrapper width={`${width}px`}>
      <DeviceImageContainer
        Container={FlexContainers.FlexRowCenter}
        width={30}
        height={30}
        minWidth={30}
        mr={8}>
        {!isImageLoaded && (
          <GradientLoader width={26} height={26} animationDuration={48} borderRadius={8} />
        )}
        <img
          src={deviceImage}
          alt="device"
          style={{ display: isImageLoaded ? "block" : "none" }}
          onLoad={() => setIsImageLoaded(true)}
        />
      </DeviceImageContainer>
      <TextOverflowWrapper highlightedText={searchedText} width={`${width}px`}>
        {cell.value}
      </TextOverflowWrapper>
    </CellWrapper>
  );
};

export default DeviceCellComponent;
